module.exports = __webpack_public_path__ + "img/pc_p3_z4.736b0ffb.png";